// Helper pentru traducerea notificărilor care vin din backend (stocate în română).
//
// NOTĂ: traducerea erorilor din backend NU se mai face aici. Backend-ul returnează acum un `code`
// stabil (vezi backend/src/utils/errorCodes.js) pe care interceptorul axios din services/api.js îl
// mapează la cheia i18n `errorCodes.<COD>` și rescrie `error.response.data.error` în limba curentă.
// Vechile `translateApiError`/`translateAxiosError` (potrivire pe substring RO, fragilă și
// neimportate nicăieri) au fost eliminate în favoarea acestei abordări bazate pe cod.

/**
 * Traduce titlul + mesajul unei notificări pe baza type + data.
 * Backend-ul stochează titlurile în română. Frontend-ul, dacă e pe EN, le retraduce.
 */
export const translateNotification = (t, notif) => {
  if (!notif) return { title: '', message: '' };
  const lang =
    (typeof window !== 'undefined' && localStorage.getItem('platforma_ssm_lang')) || 'ro';

  if (lang.startsWith('ro')) {
    return { title: notif.title || '', message: notif.message || '' };
  }

  const count = notif.data?.count || 1;
  const title = notif.title || '';
  const message = notif.message || '';

  switch (notif.type) {
    case 'SIGNATURE_TURN': {
      // Context ITM — special
      if (notif.data?.context === 'ITM') {
        if (notif.data?.cancelled || /anulat/i.test(title)) {
          return {
            title: t('notifTypes.itmCancelledTitle'),
            message: t('notifTypes.itmCancelledMsg'),
          };
        }
        return { title: t('notifTypes.itmToSignTitle'), message: t('notifTypes.itmToSignMsg') };
      }
      // Test vs fișă
      const isTest = /test/i.test(title);
      if (isTest) {
        return {
          title:
            count > 1
              ? t('notifTypes.signatureTestMulti', { count })
              : t('notifTypes.signatureTestTitle'),
          message:
            count > 1
              ? t('notifTypes.signatureTestMultiMsg', { count })
              : t('notifTypes.signatureTestMsg'),
        };
      }
      return {
        title:
          count > 1
            ? t('notifTypes.signatureTurnMulti', { count })
            : t('notifTypes.signatureTurnTitle'),
        message:
          count > 1
            ? t('notifTypes.signatureTurnMultiMsg', { count })
            : t('notifTypes.signatureTurnMsg'),
      };
    }
    case 'TRAINING_ASSIGNED': {
      // Titlu: "Instruire nouă: <course>" sau "<n> instruiri noi"
      const singleMatch = title.match(/^Instruire nouă:\s*(.+)$/i);
      if (singleMatch && count <= 1) {
        const course = singleMatch[1].trim();
        return {
          title: t('notifTypes.trainingAssignedTitleNamed', { course }),
          message: t('notifTypes.trainingAssignedMsgNamed', { course }),
        };
      }
      if (count > 1) {
        return {
          title: t('notifTypes.trainingAssignedMulti', { count }),
          message: t('notifTypes.trainingAssignedMsgMulti', { count }),
        };
      }
      // Fallback single fără match
      return {
        title: t('notifTypes.trainingAssignedTitle'),
        message: t('notifTypes.trainingAssignedMsg'),
      };
    }
    case 'IP_REMINDER': {
      // Titlu backend: "IP SSM — N angajati ..." sau "IP SU — N angajati ..."
      const ssmMatch = title.match(/^IP SSM.*?(\d+)/i);
      const suMatch = title.match(/^IP SU.*?(\d+)/i);
      if (ssmMatch) {
        return {
          title: t('notifTypes.ipSSMDueTitle', { count: parseInt(ssmMatch[1], 10) }),
          message: message || t('notifTypes.ipReminderMsg'),
        };
      }
      if (suMatch) {
        return {
          title: t('notifTypes.ipSUDueTitle', { count: parseInt(suMatch[1], 10) }),
          message: message || t('notifTypes.ipReminderMsg'),
        };
      }
      return {
        title: t('notifTypes.ipReminderTitle'),
        message: message || t('notifTypes.ipReminderMsg'),
      };
    }
    case 'PASSWORD_REMINDER': {
      return {
        title: t('notifTypes.passwordReminderTitle'),
        message: t('notifTypes.passwordReminderMsg'),
      };
    }
    default:
      return { title, message };
  }
};
